import { ClientState } from './state';

export const clientInitialState: ClientState = {
  listClient: [],
  currentClient: undefined,
};
